import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import set from 'lodash/set';

import array from '../Array';
import mixed from '../Mixed';
import { makePath } from '../utils';

const COLLECTION_SEPARATOR = '__';

let _i = 0;
export class CollectionSchemaType extends array {
  constructor(spec) {
    super(spec);
    this._indexKey = `indexKey_${_i++}`;
  }

  _isEqual(value, otherValue) {
    // collection

    const equal = isEqual(value, otherValue);

    return equal;
  }

  _cast(_value, { applyConst, parseConst, ...options } = {}) {
    let value = _value;

    if (value === undefined) {
      value = this.default();
    } else {
      value = super._cast(_value, options);
    }

    if (value) {
      if (applyConst) {
        value = this.applyConst(value);
      } else if (parseConst) {
        value = this.parseConst(value);
      }
    }
    if (
      Array.isArray(value) &&
      value.length === 1 &&
      !Object.keys(value[0]).length &&
      this._stripEmptyCollection
    ) {
      value = null;
    }
    return value;
  }
  _STRIP_COLLECTION_VALUE_WITH_EMPTY_OBJECT() {
    const next = this.clone();

    next._stripEmptyCollection = true;
    return next;
  }
  applyConst(_value) {
    return _value.map((obj) => (obj ? this._subType.applyConst(obj) : obj));
  }

  parseConst(_value) {
    return _value.map((obj) => (obj ? this._subType.parseConst(obj) : obj));
  }

  stripDefaults() {
    const next = mixed.prototype.stripDefaults.call(this);
    next._subType = next._subType.stripDefaults({ stripEmpty: false });

    return next;
  }

  encode(_value, options = {}) {
    const encodedValue = {};
    const value = this.cast(_value, { applyConst: true, ...options });
    this.traverse(({ field, key, getter }) => {
      const fieldValue = getter(value);

      if (fieldValue !== undefined && fieldValue !== null) {
        encodedValue[key] = field.stringify(fieldValue, options, key);
      }
    }, options);

    return encodedValue;
  }

  decode(_value, options = {}) {
    const decodedValue = [];
    this.traverse(({ field, key, setter }) => {
      if (_value.hasOwnProperty(key)) {
        setter(decodedValue, field.parse(_value[key], options, key));
      }
    }, options);
    const value = this.cast(decodedValue, { parseConst: true, ...options });
    return value;
  }

  traverse(callback, options) {
    const innerOptions = {
      ...options,
      path: makePath`${options.path}[${this._indexKey}]`,
    };
    this._subType.traverse(({ field, key, getter, setter }) => {
      callback({
        field: array(field).encodeSeparator(
          this._separator || COLLECTION_SEPARATOR
        ),
        key: key,
        getter: (source, indexes = {}) => {
          const path = options.path
            ? options.path.replace(/indexKey_\d+/g, (key) => {
                return indexes[key];
              })
            : options.path;
          const value = path ? get(source, path) : source;

          if (Array.isArray(value)) {
            const fieldValue = value.map((_item, i) =>
              getter(source, {
                ...indexes,
                [this._indexKey]: i,
              })
            );

            return fieldValue.some((v) => v !== undefined)
              ? fieldValue
              : undefined;
          }

          return value;
        },
        setter: (source, value, indexes = {}) => {
          if (!value.length) {
            setter(source, value, {
              ...indexes,
              [this._indexKey]: 0,
            });
          }
          return value.reduce((_s, v, i) => {
            if (v === undefined) {
              const indexesWithCurrent = { ...indexes, [this._indexKey]: i };
              const path = innerOptions.path.replace(/indexKey_\d+/g, (key) => {
                return indexesWithCurrent[key];
              });
              const model = get(_s, path);
              if (model === undefined) {
                return set(_s, path, {});
              }
              return _s;
            }

            return setter(_s, v, {
              ...indexes,
              [this._indexKey]: i,
            });
          }, source);
        },
      });
    }, innerOptions);
  }
}

export default (spec, namespace) => {
  return new CollectionSchemaType(spec, namespace);
};
